import React from "react";
import CommuCategoryAccordionMenu, { CommuCategoryNode } from "Views/Commu/CommuCategoryAccordionMenu";

interface CommuCategoryLayoutProps {
    isMobileCategoryOpen: boolean;
    selectedCategoryLabel: string;
    title: React.ReactNode;
    categories: CommuCategoryNode[];
    expandedCategory: string;
    activeBoardCode: string;
    activeSubCode?: string;
    onToggleMobileCategory: () => void;
    onCloseMobileCategory: () => void;
    onCategorySelect: (boardCode: string) => void;
    onSubMenuSelect?: (boardCode: string, subCode: string) => void;
    children: React.ReactNode;
}

const CommuCategoryLayout = ({
    isMobileCategoryOpen,
    selectedCategoryLabel,
    title,
    categories,
    expandedCategory,
    activeBoardCode,
    activeSubCode = "",
    onToggleMobileCategory,
    onCloseMobileCategory,
    onCategorySelect,
    onSubMenuSelect,
    children,
}: CommuCategoryLayoutProps) => {
    return (
        <>
            <button
                className="mobileCategoryBtn"
                onClick={onToggleMobileCategory}
            >
                <span>{selectedCategoryLabel || "카테고리"}</span>
                <span className={`category-arrow ${isMobileCategoryOpen ? "up" : "down"}`}></span>
            </button>
            <h1 className="ctntCtgrTitlTxt">{title}</h1>
            <div className="ctntLstWrap ctntPstdLstWrap faqLstContentsWrap">
                <div className="faqLst">
                    {isMobileCategoryOpen && (
                        <div className="mobileMenuOverlay" onClick={onCloseMobileCategory} />
                    )}
                    <CommuCategoryAccordionMenu
                        categories={categories}
                        expandedCategory={expandedCategory}
                        activeBoardCode={activeBoardCode}
                        activeSubCode={activeSubCode}
                        className={`faqCtgrLstWrap guideCtgrMenu ${isMobileCategoryOpen ? "mobileOpen" : ""}`}
                        onCategorySelect={onCategorySelect}
                        onSubMenuSelect={onSubMenuSelect}
                        onSubMenuClickAfter={onCloseMobileCategory}
                    />
                    {children}
                </div>
            </div>
        </>
    );
};

export default CommuCategoryLayout;